export default __webpack_public_path__ + "static/site-image-5a2437306bb607798468ddaa60df84c7.jpg";